import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAuthContext } from '../lib/context/auth-user-context';

const IndexPage = () => {
  const { richUser, loading } = useAuthContext();

  const router = useRouter();

  useEffect(() => {
    if (!loading && !richUser) {
      router.push('/login');
    }
  }, [richUser, loading]);

  return <></>;
};

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default IndexPage;
